export const IS_CHAT_OPEN = 'is-chat-open';

export const CHAT_COMPANY = 'updated-company';

export const CHAT_CHECK_INTERVAL = 30000;

export const CHAT_TOOLTIP_DELAY = 60000;

export const CHAT_REMO_REQUEST_LINK = 'https://calendly.com/d/cn9j-qw2-jvb/airslate-workflow-demo?utm_source=chat&utm_campaign=onboarding';
